export const JOB_TIME_ENTRY_REPORT_REQUEST = "JOB_TIME_ENTRY_REPORT_REQUEST";
export const JOB_TIME_ENTRY_REPORT_SUCCESS = "JOB_TIME_ENTRY_REPORT_SUCCESS";
export const JOB_TIME_ENTRY_REPORT_FAIL = "JOB_TIME_ENTRY_REPORT_FAIL";
